import { createFileRoute } from "@tanstack/react-router";

/**
 * Reseller dashboard index route (CLA-536).
 *
 * Eagerly registers the `/clawinstall/reseller/` file route; the dashboard page
 * component is deferred to `index.lazy.tsx` so its chunk stays out of the main
 * bundle.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/reseller/")({});
